import { Controller } from '@hotwired/stimulus'

// Shows the condition value input whose `data-field-paths` includes the selected
// field_path, and hides + disables the others so only the active one submits.
// Mirrors automation_trigger_controller's show/hide pattern.
export default class extends Controller {
  static targets = ['value']

  connect() {
    this.update()
  }

  fieldChanged() {
    this.update()
  }

  update() {
    const select = this.element.querySelector('select[name*="[field_path]"]')
    if (!select) return

    const field = select.value
    let matched = false

    this.valueTargets.forEach((el) => {
      const paths = (el.dataset.fieldPaths || '').split(' ')
      const visible = paths.includes(field)
      matched = matched || visible
      this.toggle(el, visible)
    })

    // Fall back to the first input if the field maps to nothing rendered
    if (!matched && this.valueTargets[0]) this.toggle(this.valueTargets[0], true)
  }

  toggle(el, visible) {
    el.classList.toggle('d-none', !visible)
    el.querySelectorAll('input, select, textarea').forEach((input) => {
      input.disabled = !visible
    })
  }
}
